import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { LNavbar } from '@/components/l'
import { authMiddleware } from '@/server/functions/auth'

export const Route = createFileRoute('/_protected')({
  beforeLoad: async () => {
    const { currentUser } = await authMiddleware()

    // Redirect to sign-in if not authenticated
    if (!currentUser) {
      throw redirect({ to: '/sign-in' })
    }

    return { currentUser }
  },
  component: ProtectedLayout,
})

function ProtectedLayout() {
  return (
    <>
      <LNavbar />
      <Outlet />
    </>
  )
}
